import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from 'widgets/portfolioPl/description/portfolioPlPreview.png';

export const portfolioPlDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Profit & Loss Widget comprises of a Performance Chart and a
                Leaves Chart and supports the selection of one or more orders
                from the Order Blotter.
            </div>
        </>
    ),
    previews: [{ src: preview, altText: 'portfolio-pl-preview' }],
};
